// src/components/organism/PasswordRecovery/RecoveryVerifyPhoneOtpForm.tsx
import React from 'react';
import { Card, Col, Container, Form, Row } from 'shared-portal-component';
import { z } from 'zod';

import AuthBodyText from '@/components/atoms/AuthBodyText/AuthBodyText';
import AuthHeaderText from '@/components/atoms/AuthHeaderText/AuthHeaderText';
import { MIN_LEN } from '@/constants';

const CODE_LENGTH = 6;

const schema = z.object({
  code: z
    .string()
    .length(CODE_LENGTH, `Code must be exactly ${CODE_LENGTH} digits`)
    .regex(/^\d+$/, 'Code must contain only digits'),
});

const fields = [
  {
    name: 'code',
    label: 'Code',
    placeholder: 'Enter the 6-digit code',
    required: true,
    variant: 'outline' as const,
    type: 'code',
    numValues: CODE_LENGTH,
  },
];

interface RecoveryVerifyPhoneOtpFormProps {
  maskedPhone?: string;
  onSubmit: (code: string) => void;
}

export default function RecoveryVerifyPhoneOtpForm({
  maskedPhone,
  onSubmit,
}: RecoveryVerifyPhoneOtpFormProps) {
  const label =
    typeof maskedPhone === 'string' && maskedPhone.trim().length > MIN_LEN
      ? `We’ve sent a 6-digit code to your phone number ${maskedPhone}.`
      : `We’ve sent a 6-digit code to your phone number.`;

  return (
    <Container fluid>
      <Card>
        <Row spacing="md">
          <Col size={12}>
            <AuthHeaderText text="Verify your phone" />
            <AuthBodyText>
              {label} Please enter it below to continue.
            </AuthBodyText>
          </Col>
        </Row>

        <Row justify="center" spacing="none">
          <Form
            schema={schema}
            fields={fields}
            onSubmit={(values: { code: string }) => {
              onSubmit(values.code);
            }}
          />
        </Row>
      </Card>
    </Container>
  );
}
